import { render, staticRenderFns } from "./otherPtModal.vue?vue&type=template&id=20e20fb6&scoped=true&"
import script from "./otherPtModal.vue?vue&type=script&lang=js&"
export * from "./otherPtModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e20fb6",
  null
  
)

export default component.exports